import React, { useState, useEffect, useRef } from 'react';
import { getRouteFromPath } from '../../../Routes';
import {
  hasPermissionAdmin,
  pathRedirect,
} from '../../../elements/lib/hasPermissionAdmin';
import { pathTo } from '../../../Routes';
import { Redirect } from 'react-router-dom';
import { Translation } from 'react-i18next';
import QueryString from '../../../../../lib/QueryString';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';
import scrollToTop from '../../../elements/lib/scrollToTop';
import LearningAdminHeaderScreen from '../containers/LearningAdminHeaderScreenContainer';
import LearningAdminList from './LearningAdminList';
import LearningAdminModuleSeriePreview from '../containers/LearningAdminModuleSerieModalPreviewContainer';
import LearningAdminModulePreview from '../containers/LearningAdminModuleModalPreviewContainer';
import { MixpanelTracker } from '../../../../../lib/Mixpanel';

function LearningsAdminScreen({ role, ...props }) {
  const [redirect, setRedirect] = useState(null);
  const prevProps = useRef();

  const limit = parseInt(
    props.match.params.limit ? props.match.params.limit : 10
  );

  const page = parseInt(props.match.params.page ? props.match.params.page : 1);

  const { order, view, key, ...filter } = QueryString.parse(
    props.location.search
  );

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    prevProps.current = props;
  });

  useEffect(() => {
    Logger.log('silly', `LearningsAdminScreen.componentDidUpdate()`);
    const route = getRouteFromPath(props.location.pathname);
    const screen = hasPermissionAdmin();

    if (
      prevProps.current &&
      props.partnershipId !== prevProps.current.partnershipId
    ) {
      if (route.screen !== pathRedirect(screen)[0]) {
        setRedirect(pathRedirect(screen)[0]);
      }
    }
  }, [props.location.pathname, props.partnershipId]);

  const trackerActions = (eventMixpanel, params = {}) => {
    if (role !== 1) {
      MixpanelTracker.mixpanelTrack(eventMixpanel, {
        partnershipName: props.partnershipName ?? 'No partnership',
        partnershipId: props.partnershipId ?? 'No partnership',
        ...params,
      });
    }
  };

  if (redirect) {
    return <Redirect to={pathTo(redirect)} />;
  }

  return (
    <Translation>
      {(t) => (
        <>
          <DocumentHead title={t('learnings_route_list')} />
          <LearningAdminHeaderScreen trackerActions={trackerActions} />
          <LearningAdminList
            page={page}
            limit={limit}
            order={order}
            view={view ?? 'grid'}
            filter={filter}
            component='LearningsAdminScreen'
            activeKey={key ?? 'module_serie'}
            trackerActions={trackerActions}
          />
          <LearningAdminModulePreview trackerActions={trackerActions} />

          <LearningAdminModuleSeriePreview trackerActions={trackerActions} />
        </>
      )}
    </Translation>
  );
}

export default LearningsAdminScreen;

Logger.log('silly', `LearningsAdminScreen loaded.`);
